import {createContext} from "react";
import {Project} from "../Models/Project";
import {AdminProjectDashboardData} from "../interface/AdminDashboard.interface";

export interface AdminProjectContextType {
    projects: Project[];
    selectedProject: Project | null;
    reloadDashboard: boolean;
    refreshTrigger: number;
    setSelectedProject: (project: Project | null) => void;
    setReloadDashboard: (reload: boolean) => void;
    refreshProjects: () => Promise<void>;
    loadParticipantsForProject: (projectId: string, forceRefresh?: boolean) => Promise<any[]>;
    selectProjectWithParticipants: (project: Project) => Promise<void>;
    loading: boolean;
    error: string | null;
}

export const AdminProjectContext = createContext<AdminProjectContextType>({
    projects: [],
    selectedProject: null,
    reloadDashboard: false,
    refreshTrigger: 0,
    setSelectedProject: () => {},
    setReloadDashboard: () => {},
    refreshProjects: async () => {},
    loadParticipantsForProject: async () => [],
    selectProjectWithParticipants: async () => {},
    loading: false,
    error: null,
});
